// Mock data for Udbhav 2.0 platform
export const appList = [
  { code: "HRS", name: "HRS", image: "/images/1.png" },
  { code: "WIOP", name: "WIOP", image: "/images/2.png" },
  { code: "HCMS", name: "HCMS", image: "/images/3.png" },
  { code: "GNO", name: "GNO", image: "/images/4.png" },
  { code: "MZI", name: "MZI", image: "/images/5.png" },
  { code: "RIF", name: "RIF", image: "/images/6.png" },
  { code: "WCP", name: "WCP", image: "/images/7.png" },
  { code: "WIS", name: "WIS", image: "/images/8.png" },
  { code: "SLFT", name: "SLFT", image: "/images/9.png" },
  { code: "TCO", name: "TCO", image: "/images/TCO Image .png" },
  { code: "TLM", name: "TLM", image: "/images/11.png" },
  { code: "PMP", name: "PMP", image: "/images/12.png" },
  { code: "WIOG", name: "WIOG", image: "/images/13.png" },
  { code: "DBG", name: "DBG", image: "/images/14.png" },
  { code: "SIO", name: "SIO", image: "/images/21.png" },
  { code: "PFE", name: "PFE", image: "/images/16.png" },
  { code: "EORX", name: "EORX", image: "/images/17.png" },
  { code: "FCML", name: "FCML", image: "/images/18.png" },
  { code: "DFM", name: "DFM", image: "/images/19.png" },
  { code: "FWI", name: "FWI", image: "/images/20.png" },
];

// Mock data for AIX application details
export const appDetails = [
  {
    code: "HRS",
    ucId: "U1UCI287",
    title: "Enhancing hydrocarbon recovery through AI powered stimulation job analysis",
    shortTitle: "Hydrocarbon Recovery and Stimulation",
    overview:
      "AI-driven system that enhances hydrocarbon recovery by analyzing stimulation job parameters and reservoir responses.",
    features: [
      "Real-time analysis of stimulation job data",
      "AI-powered optimization of hydrocarbon recovery",
      "Visualization of stimulation effectiveness",
    ],
  },
  {
    code: "WIOP",
    ucId: "U1UCI512",
    title: "Water Injection Optimization on oil reservoirs",
    shortTitle: "Water Injector Optimizer",
    overview:
      "Optimizes water injection patterns using AI models to maximize reservoir performance and minimize water cut.",
    features: [
      "AI-based reservoir behavior modeling",
      "Optimization of injector-producer pairings",
      "Reduction of water cut and operational costs",
    ],
  },
  {
    code: "HCMS",
    ucId: "U1UCI345",
    title: "AI powered Hole Cleaning Monitoring System using Physics-based and Computer Vision models",
    shortTitle: "Hole Cleaning Monitoring System",
    overview:
      "Uses physics-based and vision-based AI models to monitor and optimize hole cleaning efficiency during drilling.",
    features: [
      "Real-time detection of inefficient hole cleaning",
      "Physics-based modeling integrated with visual analysis",
      "Improved drilling efficiency and safety",
    ],
  },
  {
    code: "GNO",
    ucId: "U1UCI236",
    title: "Optimization and Anomaly Detection of Surface Gas Network",
    shortTitle: "Gas Network Optimizer",
    overview:
      "AI system for detecting anomalies and optimizing performance of surface gas networks in real-time.",
    features: [
      "Anomaly detection using AI and physics models",
      "Optimization of gas flow and pressure",
      "Predictive maintenance insights",
    ],
  },
  {
    code: "MZI",
    ucId: "U1UCI255_257_390",
    title: "Missed Zone Identification",
    shortTitle: "Missed Zone Identifier",
    overview:
      "AI-based tool for identifying missed hydrocarbon zones using multi-source well log analysis.",
    features: [
      "Machine learning-based pattern recognition",
      "Cross-validation using geological models",
      "Improved recovery estimation",
    ],
  },
  {
    code: "RIF",
    ucId: "U1UCI447B",
    title: "Real time inventory forecasting",
    shortTitle: "Real-time Inventory Forecaster",
    overview:
      "Predictive analytics tool for real-time forecasting of drilling and production inventory requirements.",
    features: [
      "Predictive supply chain forecasting",
      "Integration with live inventory systems",
      "Reduction in material wastage",
    ],
  },
  {
    code: "WCP",
    ucId: "U1UCI392",
    title:
      "AI enabled Onshore Exploratory Well Cost Planning and its Variance Analysis",
    shortTitle: "Well Cost Planner",
    overview:
      "AI-powered tool for estimating and analyzing cost variances for exploratory wells.",
    features: [
      "Variance analysis and forecasting",
      "Cost breakdown visualization",
      "Integration with project management tools",
    ],
  },
  {
    code: "WIS",
    ucId: "U1UCI077",
    title: "AI/ML Based Candidate Well Selection for Well Intervention",
    shortTitle: "Well Intervention Selector",
    overview:
      "ML-driven solution for selecting optimal well intervention candidates based on production data.",
    features: [
      "AI-driven well selection",
      "Production uplift prediction",
      "Smart ranking dashboard",
    ],
  },
  {
    code: "SLFT",
    ucId: "U1UCI359",
    title: "Smartlift",
    shortTitle: "SmartLift",
    overview:
      "AI-based lift optimization platform that enhances artificial lift performance and efficiency.",
    features: [
      "Lift performance monitoring",
      "Predictive maintenance alerts",
      "Automated lift tuning recommendations",
    ],
  },
  {
    code: "TCO",
    ucId: "U1UCI196",
    title: "Air Travel Cost Optimisation",
    shortTitle: "Travel Cost Optimizer",
    overview:
      "Tool for optimizing corporate air travel costs through data-driven recommendations.",
    features: [
      "Travel spend analysis",
      "Route optimization",
      "Dynamic policy-based savings insights",
    ],
  },
  {
    code: "TLM",
    ucId: "U1UCI010_151",
    title: "Tanker loading - Unloading App",
    shortTitle: "Tanker Load Manager",
    overview:
      "Manages tanker loading and unloading operations using IoT and predictive analytics.",
    features: [
      "Digital tracking of tanker operations",
      "Predictive delay management",
      "Real-time dashboard monitoring",
    ],
  },
  {
    code: "PMP",
    ucId: "U1UCI458",
    title: "Predictive Maintenance of Mud Pumps",
    shortTitle: "Predictive Mud Pump",
    overview:
      "AI system that predicts mud pump failures using vibration and pressure sensor data.",
    features: [
      "Early failure detection",
      "AI-based condition monitoring",
      "Maintenance scheduling recommendations",
    ],
  },
  // ✅ NEWLY ADDED BELOW
  {
    code: "WIOG",
    ucId: "U1UCI601",
    title: "Well Intervention Opportunities Generation using AI",
    shortTitle: "Well Intervention Opportunity Generator",
    overview:
      "AI-driven system that identifies and prioritizes potential well intervention opportunities based on real-time production data.",
    features: [
      "Automated opportunity identification",
      "AI-assisted prioritization of interventions",
      "Production uplift estimation",
    ],
  },
  {
    code: "DBG",
    ucId: "U1UCI602",
    title: "AI Assisted Drill Bit Grading and Evaluation",
    shortTitle: "Drill Bit Grader",
    overview:
      "AI-assisted application for grading and evaluating drill bits using image analysis and historical performance data.",
    features: [
      "Automated drill bit wear detection",
      "Performance-based grading metrics",
      "Historical analytics for optimized selection",
    ],
  },
  {
    code: "SIO",
    ucId: "U1UCI603",
    title: "SAP Inventory Optimization: Deduplication & Consolidation & UI",
    shortTitle: "SAP Inventory Optimizer",
    overview:
      "AI-powered SAP add-on that eliminates duplicate entries, consolidates materials, and optimizes stock visibility.",
    features: [
      "Duplicate material detection and merging",
      "Smart inventory consolidation",
      "Real-time UI for material management",
    ],
  },
  {
    code: "PFE",
    ucId: "U1UCI604",
    title: "Estimated Profitability Preparation for MIS & Advance Tax",
    shortTitle: "Profitability Estimator",
    overview:
      "Financial AI tool that automates profitability estimation for MIS and advance tax preparation using predictive analytics.",
    features: [
      "Automated profitability computation",
      "Integration with MIS systems",
      "Forecasting-based tax insights",
    ],
  },
  {
    code: "EORX",
    ucId: "U1UCI605",
    title: "Agentic AI for Enhanced Oil Recovery (EORX)",
    shortTitle: "EORX Agent AI",
    overview:
      "AI agent that optimizes EOR techniques using reservoir simulation, production data, and machine learning models.",
    features: [
      "AI-driven EOR simulation and control",
      "Production optimization using agentic models",
      "Adaptive learning for reservoir response",
    ],
  },
  {
    code: "FCML",
    ucId: "U1UCI606",
    title: "Facies Characterisation by Machine Learning",
    shortTitle: "Facies Characterization AI",
    overview:
      "AI-based system that automates facies classification using well logs and seismic data for better reservoir modeling.",
    features: [
      "Machine learning-based facies prediction",
      "Integration with geological data",
      "Enhanced reservoir characterization accuracy",
    ],
  },
  {
    code: "DFM",
    ucId: "U1UCI607",
    title: "Smart Drilling Fluid Management using AI & Digital Techniques",
    shortTitle: "Drilling Fluid Manager",
    overview:
      "AI and digital-driven system that monitors, predicts, and optimizes drilling fluid properties in real time.",
    features: [
      "Real-time mud property tracking",
      "AI-based formulation recommendations",
      "Waste reduction and cost optimization",
    ],
  },
  {
    code: "FWI",
    ucId: "U1UCI608",
    title: "Full Waveform Inversion (FWI) for Seismic Model Building",
    shortTitle: "Full Waveform Inversion",
    overview:
      "Advanced FWI platform that enhances seismic model building accuracy using AI and physics-informed inversion algorithms.",
    features: [
      "Physics-informed AI inversion",
      "High-resolution seismic model generation",
      "Faster convergence and reduced uncertainty",
    ],
  },
];


// // Mock data for AIX application details
// export const appDetails = [
//   {
//     code: "HRS",
//     ucId: "U1UCI287",
//     title: "Enhancing hydrocarbon recovery through AI powered stimulation job analysis",
//     shortTitle: "Hydrocarbon Recovery and Stimulation",
//     overview:
//       "AI-driven system that enhances hydrocarbon recovery by analyzing stimulation job parameters and reservoir responses.",
//     features: [
//       "Real-time analysis of stimulation job data",
//       "AI-powered optimization of hydrocarbon recovery",
//       "Visualization of stimulation effectiveness"
//     ],
//   },
//   {
//     code: "WIOP",
//     ucId: "U1UCI512",
//     title: "Water Injection Optimization on oil reservoirs",
//     shortTitle: "Water Injector Optimizer",
//     overview:
//       "Optimizes water injection patterns using AI models to maximize reservoir performance and minimize water cut.",
//     features: [
//       "AI-based reservoir behavior modeling",
//       "Optimization of injector-producer pairings",
//       "Reduction of water cut and operational costs"
//     ],
//   },
//   {
//     code: "HCMS",
//     ucId: "U1UCI345",
//     title: "AI powered Hole Cleaning Monitoring System using Physics-based and Computer Vision models",
//     shortTitle: "Hole Cleaning Monitoring System",
//     overview:
//       "Uses physics-based and vision-based AI models to monitor and optimize hole cleaning efficiency during drilling.",
//     features: [
//       "Real-time detection of inefficient hole cleaning",
//       "Physics-based modeling integrated with visual analysis",
//       "Improved drilling efficiency and safety"
//     ],
//   },
//   {
//     code: "GNO",
//     ucId: "U1UCI236",
//     title: "Optimization and Anomaly Detection of Surface Gas Network",
//     shortTitle: "Gas Network Optimizer",
//     overview:
//       "AI system for detecting anomalies and optimizing performance of surface gas networks in real-time.",
//     features: [
//       "Anomaly detection using AI and physics models",
//       "Optimization of gas flow and pressure",
//       "Predictive maintenance insights"
//     ],
//   },
//   {
//     code: "MZI",
//     ucId: "U1UCI255_257_390",
//     title: "Missed Zone Identification",
//     shortTitle: "Missed Zone Identifier",
//     overview:
//       "AI-based tool for identifying missed hydrocarbon zones using multi-source well log analysis.",
//     features: [
//       "Machine learning-based pattern recognition",
//       "Cross-validation using geological models",
//       "Improved recovery estimation"
//     ],
//   },
//   {
//     code: "RIF",
//     ucId: "U1UCI447B",
//     title: "Real time inventory forecasting",
//     shortTitle: "Real-time Inventory Forecaster",
//     overview:
//       "Predictive analytics tool for real-time forecasting of drilling and production inventory requirements.",
//     features: [
//       "Predictive supply chain forecasting",
//       "Integration with live inventory systems",
//       "Reduction in material wastage"
//     ],
//   },
//   {
//     code: "WCP",
//     ucId: "U1UCI392",
//     title: "AI enabled Onshore Exploratory Well Cost Planning and its Variance Analysis",
//     shortTitle: "Well Cost Planner",
//     overview:
//       "AI-powered tool for estimating and analyzing cost variances for exploratory wells.",
//     features: [
//       "Variance analysis and forecasting",
//       "Cost breakdown visualization",
//       "Integration with project management tools"
//     ],
//   },
//   {
//     code: "WIS",
//     ucId: "U1UCI077",
//     title: "AI/ML Based Candidate Well Selection for Well Intervention",
//     shortTitle: "Well Intervention Selector",
//     overview:
//       "ML-driven solution for selecting optimal well intervention candidates based on production data.",
//     features: [
//       "AI-driven well selection",
//       "Production uplift prediction",
//       "Smart ranking dashboard"
//     ],
//   },
//   {
//     code: "SLFT",
//     ucId: "U1UCI359",
//     title: "Smartlift",
//     shortTitle: "SmartLift",
//     overview:
//       "AI-based lift optimization platform that enhances artificial lift performance and efficiency.",
//     features: [
//       "Lift performance monitoring",
//       "Predictive maintenance alerts",
//       "Automated lift tuning recommendations"
//     ],
//   },
//   {
//     code: "TCO",
//     ucId: "U1UCI196",
//     title: "Air Travel Cost Optimisation",
//     shortTitle: "Travel Cost Optimizer",
//     overview:
//       "Tool for optimizing corporate air travel costs through data-driven recommendations.",
//     features: [
//       "Travel spend analysis",
//       "Route optimization",
//       "Dynamic policy-based savings insights"
//     ],
//   },
//   {
//     code: "TLM",
//     ucId: "U1UCI010_151",
//     title: "Tanker loading - Unloading App",
//     shortTitle: "Tanker Load Manager",
//     overview:
//       "Manages tanker loading and unloading operations using IoT and predictive analytics.",
//     features: [
//       "Digital tracking of tanker operations",
//       "Predictive delay management",
//       "Real-time dashboard monitoring"
//     ],
//   },
//   {
//     code: "PMP",
//     ucId: "U1UCI458",
//     title: "Predictive Maintenance of Mud Pumps",
//     shortTitle: "Predictive Mud Pump",
//     overview:
//       "AI system that predicts mud pump failures using vibration and pressure sensor data.",
//     features: [
//       "Early failure detection",
//       "AI-based condition monitoring",
//       "Maintenance scheduling recommendations"
//     ],
//   },
// ];

export const navigationItems = [
  { name: 'Home', path: '/' },
  // { name: 'Submit Your Idea', path: '/submit-idea' },
  { name: 'Knowledge Center', path: '/knowledge-center' },
  // { name: 'Previous Editions', path: '/previous-editions' },
  // { name: 'Content', path: '/content' },
  // { name: 'Alumni Platform ', path: '/alumni' },
  { name: 'Udbhav 1.0 Awards', path: '/udbhav-awards' },
  { name: 'Udbhav 1.0 Use Cases', path: '/udbhav-case' },
  //  { name: "AIX Platform", path: "/aix-platform" },
  { name: 'Help', path: '/help' }
];

export const timelineDates = [
  { phase: 'Idea Submission Opens', date: 'March 1, 2025' },
  { phase: 'Submission Deadline', date: 'April 30, 2025' },
  { phase: 'Evaluation Period', date: 'May 1 - May 31, 2025' },
  { phase: 'Finalists Announced', date: 'June 15, 2025' },
  { phase: 'Prototype Development', date: 'July - September 2025' },
  { phase: 'Final Presentations', date: 'October 2025' }
];

export const whatsNew = [
  {
    title: 'Phase 1: Idea Submission & Evaluation',
    description: 'Submit AI-driven ideas rooted in real ONGC challenges. Each idea undergoes structured evaluation and expert review to shortlist high-potential, business-relevant use cases.',
    icon: 'Target',
    dates: [
      '09 Jan (Friday) – 18 Jan (Sunday)'
    ]
  },
  {
    title: 'Phase 2: Use Case Development',
    description: 'Shortlisted teams receive hands-on training and expert mentorship to transform ideas into working prototypes using real data and practical AI techniques.',
    icon: 'Users',
    dates: [
      '11 Feb (Wednesday) - 27 Apr (Monday)'
    ]
  },
  {
    title: 'Phase 3: Finale (Demo Day)',
    description: 'Teams present working solutions to ONGC’s top management, celebrating innovation, recognizing excellence, and paving the way for real-world deployment and scale.',
    icon: 'Network',
    dates: [
      '10th July (Friday)'
    ]
  }
];


export const achievements = [
  {
    category: 'For Projects',
    items: [
      '21 prototypes developed',
      'Multiple projects in active implementation',
      'Real-world business impact demonstrated'
    ],
    icon: 'Rocket'
  },
  {
    category: 'For ONGC',
    items: [
      'Sparked a culture of innovation',
      'Data-driven decision-making enabled',
      'Alumni program with transformation ambassadors'
    ],
    icon: 'Building'
  },
  {
    category: 'For Participants',
    items: [
      'Upgraded skills of over 100 individuals',
      'Visibility across top management',
      'Presented to MCOD and senior leadership'
    ],
    icon: 'Award'
  }
];

export const dignitaryQuotes = [
  "This is not just a hackathon, this is a movement.",
  "When employees get a chance to be heard, you can see how much talent was waiting to shine.",
  "Unhe Gumaan ki meri udaan kuch kam hain, aur mujhe yakeen ki ye aasmaan kuch kam hain.",
  "A small idea can translate into something big and valuable for the company.",
  "The teamwork really matters; when people from different domains collaborate, they create great ideas that can be implemented.",
  "Our people have built confidence in the platform and can scale it further independently.",
  "People worked beyond office hours, showing how committed and capable they are.",
  "Seekhna kaise hai, ye maine is event se seekha.",
  "The support and handholding from the platform made it possible for employees to deliver end-to-end solutions.",
  "The young employees displayed amazing energy and commitment, learning coding and AI tools even without prior experience.",
  "The hackathon created an AI & ML culture, giving employees a platform to showcase and refine their ideas.",
  "We provided infrastructure and upskilling opportunities; the teams took full advantage of it and delivered impressive results.",
  "The diversity of skills among participants created new innovative solutions for the company.",
  "This initiative broke barriers—people from non-technical backgrounds learned coding and AI workflows successfully.",
  "If we keep this momentum alive, we'll set benchmarks for the whole sector.",
  "A small idea can create significant value and impact for the organization."
];

export const participantFeedback = [
  {
    name: "Deepa",
    ideaId: "UC1045",
    feedback: "Udbhav transformed how I approach AI solutions in our daily operations",
    full: "Udbhav transformed how I approach AI solutions in our daily operations."
  },
  {
    name: "Alok",
    ideaId: "UC2103",
    feedback: "An incredible learning experience that bridged the gap between ideas and implementation.",
    full: "From a non-technical background, I built a working ML model. This platform changed my perspective on what's possible with the right guidance and resources."
  },
  {
    name: "V T Sakhare",
    ideaId: "UC1567",
    feedback: "The mentorship and collaborative environment made all the difference."
  },
  {
    name: "Sakshi",
    ideaId: "UC1889",
    feedback: "From concept to prototype, Udbhav empowered us to innovate fearlessly.",
    full: "From concept to prototype, Udbhav empowered us to innovate fearlessly."
  },
  {
    name: "Veena",
    ideaId: "UC1889",
    feedback: "The journey from idea submission to Demo Day was transformative.",
    full: "The journey from idea submission to Demo Day was transformative."
  },
  {
    name: "Manoj",
    ideaId: "UC2245",
    feedback: "A platform that truly values employee innovation and creativity."
  },
  {
    name: "Aninda",
    ideaId: "UC2245",
    feedback: "The technical guidance we received was world-class."
  },
  {
    name: "M P Naik",
    ideaId: "UC1723",
    feedback: "Udbhav showcases ONGC's commitment to AI-driven transformation."
  },
  {
    name: "M Aditya",
    ideaId: "UC1723",
    feedback: "Working with cross-functional teams opened new perspectives."
  },
  {
    name: "R S Thakur",
    ideaId: "UC1723",
    feedback: "An opportunity to contribute meaningfully to ONGC's digital future."
  },
  {
    name: "Bhartendu",
    ideaId: "UC1723",
    feedback: "The recognition and learning made every effort worthwhile."
  },
  {
    name: "Chaitanya",
    ideaId: "UC1723",
    feedback: "Udbhav proved that innovation thrives when given the right platform."
  },
];

export const timelineMilestones = [
  {
    id: 1,
    title: "Launch",
    icon: "Rocket",
    description: "Udbhav 1.0 launched to ignite AI led innovation at ONGC",
    details:
      "Udbhav was conceived as a first of its kind internal innovation program, aimed at shifting AI from a niche capability to a shared organizational mindset. It provided a structured platform, leadership backing, and a clear roadmap for employees to explore problem-solving through AI."
  },
  {
    id: 2,
    title: "Idea Submission",
    icon: "Lightbulb",
    description: "Employees submitted 591 AI driven problem statements",
    details:
      "The idea submission phase witnessed participation from across locations, disciplines, and experience levels. Submissions reflected ground level operational challenges, safety concerns, and efficiency gaps, demonstrating how deeply employees understood ONGC’s day to day realities."
  },
  {
    id: 3,
    title: "Shortlisting",
    icon: "CheckCircle",
    description: "27 ideas progressed to the innovation pipeline",
    details:
      "Ideas underwent multiple rounds of assessment involving technical feasibility checks, business impact evaluation, and alignment with ONGC’s strategic priorities. Only those with clear implementation pathways and measurable outcomes advanced to the next stage."
  },
  {
    id: 4,
    title: "POC Development",
    icon: "Code",
    description: "Teams converted ideas into functional AI prototypes",
    details:
      "Participants transitioned from ideation to execution by building proof of concepts using real datasets, AI models, and workflow integrations. This phase emphasized learning by doing, iterative improvement, and close mentorship to translate concepts into working solutions."
  },
  {
    id: 5,
    title: "Demo Day",
    icon: "Award",
    description: "Final solutions presented to ONGC leadership",
    details:
      "On Demo Day, teams demonstrated their solutions in live environments, explaining problem context, technical approach, and business value. Leadership interactions helped validate real world relevance and guided future scaling decisions."
  },
  {
    id: 6,
    title: "Impact",
    icon: "TrendingUp",
    description: "Selected solutions entered the deployment phase",
    details:
      "The program moved beyond innovation theater, with shortlisted solutions earmarked for pilot rollouts and integration into existing systems. These initiatives are expected to influence operational efficiency, safety compliance, and data driven decision-making at scale."
  }
];


export const knowledgeCenterVideos = [
  {
    id: 1,
    title: 'Introduction to AI in Oil & Gas',
    description: 'Comprehensive overview of AI applications in the energy sector',
    duration: '45 mins',
    category: 'Training',
    thumbnail: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80'
  },
  {
    id: 2,
    title: 'SAS Training Session - Data Analytics',
    description: 'Advanced data analytics techniques for business insights',
    duration: '60 mins',
    category: 'SAS Training',
    thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80'
  },
  {
    id: 3,
    title: 'Machine Learning Demo',
    description: 'Hands-on demonstration of ML model development',
    duration: '30 mins',
    category: 'Demo',
    thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&q=80'
  }
];

export const previousFinalists = [
  {
    id: 1,
    title: 'AI Enabled Physics-Based Optimization of Water Injection in Oil Reservoirs',
    team: 'Optiinject Team',
    description: 'U1UCI512 — Developed by Aninda Ghosh, Anil Thapliyal, A Rangaswamy, Rakesh Meena, Naveen M, and Pratik Ramesh Kumawat.',

  },
  {
    id: 2,
    title: 'AI Powered Hole Cleaning Monitoring System using Physics Based and Computer Vision Models',
    team: 'Drishti Team',
    description: 'U1UCI345 — Developed by Bala Saidulu Nallagondla, Santosh Kumar Gupta, Murugeshan M K, Srinivasan J, Rajjan Singh Thakur, Raghu Ottoor Menon, Janeshwar Prasad, Mathialagan P, and Ramu Pedumajji.',

  },
  {
    id: 3,
    title: 'Optimization and Anomaly Detection of Surface Gas Network',
    team: 'Wadu AI Team',
    description: 'U1UCI236, U1UCI496 — Developed by Bhartendu Bhardwaj, Neeraj Kumar, Chaitanya Bhatt, Bhargab Goswami, and Randheer S Meena.',

  },
  {
    id: 4,
    title: 'Missed Zone Identification',
    team: 'Pay Zone AI Team',
    description: 'U1UCI255, U1UCI390, U1UCI257 — Developed by Abhishek Kumar, Jitendra Bisoi, Nitesh Kumar Jain, Hitisha Dadlani, Parth Chauhan, Mahesh Pareek, Dhiraj Singh, and Atul Kumar Pandey.',

  },
  {
    id: 5,
    title: 'Real-Time Inventory Forecasting',
    team: 'Inv_Optima Team',
    description: 'U1UCI447_B — Developed by Tiju Joy, Shameer K, Muhammed Kamil, Rahul M S, and Onsuya Buragohain.',

  },
  {
    id: 6,
    title: 'AI Enabled Onshore Exploratory Well Cost Planning and Variance Analysis',
    team: 'Well AI Team',
    description: 'U1UCI392 — Developed by Veral Agarwal, Shailendra Kumar, Jatindra Kumar Samal, and Jitendra Kumar.',

  },
  {
    id: 7,
    title: 'AI/ML Based Candidate Well Selection for Well Intervention',
    team: 'WellEx Team',
    description: 'U1UCI077, U1UCI376 — Developed by Kaushal Agrawala, Sohil Shah, and Alok Verma.',

  },
  {
    id: 8,
    title: 'Smartlift',
    team: 'Pravaah_AI Team',
    description: 'U1UCI359 — Developed by Ritesh Parashar, Akhil Jain, and Mayank Kumar.',

  },
  {
    id: 9,
    title: 'Air Travel Cost Optimisation',
    team: 'Crew Path Innovators Team',
    description: 'U1UCI196 — Developed by Harish N, Vishal Mittal, Jagpreet Singh, Kishore Dola, Vineet Arora, and Anhishek Sharma.',

  },
  {
    id: 10,
    title: 'Tanker Loading - Unloading App',
    team: 'Team Nirantar',
    description: 'U1UCI010, U1UCI151 — Developed by Bhavesh Parmar and Tejpreet Singh.',

  },
  {
    id: 11,
    title: 'Predictive Maintenance of Mud Pumps',
    team: 'Predictive Pulse Team',
    description: 'U1UCI458 — Developed by Mohammad Farhan, Ashish Sharma, Manoj Kumar Agnihotri, Mukul Gogoi, Anurag Verma, and Rupesh Singh.',

  },
  {
    id: 12,
    title: 'Well Intervention Opportunities Generation using AI',
    team: 'Wisdom Team',
    description: 'U1UCI295, U1UCI322 — Developed by Dherendra Kumar Panday, Sanjoy Das, Mayank Kumar, Neeraj Doneria, Pradeep Kumar, Pramod Azad, Sujit Kumar Biswas, Anita Kumari, Shubham Gupta, and Swati.',
    status: 'Prototype Completed',
  },
  {
    id: 13,
    title: 'AI Assisted Drill Bit Grading and Evaluation',
    team: 'MargDash Team',
    description: 'U1UCI263 — Developed by Bala Saidulu Nallagondla, Santosh Kumar Gupta, Rajjan Singh Thakur, Ramu Pedumajji, Manohar Kumar Kasi, Raghu Ottoor Menon, Srinivasan J, and Bikash Acharya.',

  },
  {
    id: 14,
    title: 'SAP Inventory Optimization: Deduplication & Consolidation & UI',
    team: 'Invoptima Team',
    description: 'U1UCI447_A — Developed by Tiju Joy, Shameer K, Muhammed Kamil, Rahul M S, and Onsuya Buragohain.',

  },
  {
    id: 15,
    title: 'Preparation of Estimated Profitability for MIS and Advance Tax',
    team: 'ProfitPro AI Team',
    description: 'U1UCI351 — Developed by Veral Agarwal, Shailendra Kumar, and Anil Singh Chauhan.',

  },
  {
    id: 16,
    title: 'Agentic AI for EOR',
    team: 'Drishtant Team',
    description: 'U1UCI115 — Developed by Gaurav Mishra, Rakesh Meena, Nabajit Baruah, Yogesh Mohan, Nikhil Srivastava, Anshul Jha, Arpit Buddhiwant, and Jayant Boddu.',

  },
  {
    id: 17,
    title: 'Facies Characterisation by Machine Learning Techniques',
    team: 'Lithomind Team',
    description: 'U1UCI044 — Developed by Satyajit Mondal, Sanjai Kumar Singh, Bhaskar Acharya, Jayendra Nath Chakraborty, and Mohsin Dar.',

  },
  {
    id: 18,
    title: 'Smart Drilling Fluid Management using AI and Digital Techniques',
    team: 'Digi Fluids Team',
    description: 'U1UCI366 — Developed by Bala Saidulu Nallagondla, Santosh Kumar Gupta, Murugeshan M K, Srinivasan J, Rajjan Singh Thakur, Raghu Ottoor Menon, Janeshwar Prasad, Mathialagan P, and Ramu Pedumajji.',

  },
  {
    id: 19,
    title: 'Full Waveform Inversion (FWI) for Advanced Seismic Model Building',
    team: 'GeoPulse Team',
    description: 'U1UCI013 — Developed by Smitha N C, Parimal Pritosh, Sanjai Kumar Singh, Manjula Singamsetty, Mandeep Singh, Mohammad Wasif Ansari, and Maduboyina Sudhakar.',

  },
  {
    id: 20,
    title: 'Enhancing Hydrocarbon Recovery through AI Powered Stimulation Job Analysis',
    team: 'WellStim Wizard Team',
    description: 'U1UCI287 — Developed by Dip Narayan Singh, Sugata Guchhait, Mahadev D Kaulaskar, Girish Kumar, Nirmal Kumar Mishra, Yogesh Singh, Amit Mishra, and Praveen Kumar Jha.',

  },
];

export const contentLibrary = [
  {
    id: 1,
    type: 'article',
    title: 'The Journey of Digital Transformation at ONGC',
    author: 'Innovation Team',
    date: '2024-10-15',
    excerpt: 'Exploring how Udbhav 1.0 catalyzed a cultural shift towards innovation',
    readTime: '8 min read'
  },
  {
    id: 2,
    type: 'video',
    title: 'Udbhav 1.0 Success Stories',
    duration: '12 mins',
    thumbnail: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80'
  },
  {
    id: 3,
    type: 'article',
    title: 'AI Implementation Best Practices',
    author: 'Tech Team',
    date: '2024-11-20',
    excerpt: 'Key learnings from implementing AI solutions in the field',
    readTime: '10 min read'
  }
];

export const alumniDirectory = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    batch: 'Udbhav 1.0',
    project: 'Predictive Maintenance System',
    expertise: 'Machine Learning, IoT',
    location: 'Mumbai',
    email: 'rajesh.kumar@ongc.co.in'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    batch: 'Udbhav 1.0',
    project: 'Smart Drilling Optimizer',
    expertise: 'Data Science, Analytics',
    location: 'Dehradun',
    email: 'priya.sharma@ongc.co.in'
  },
  {
    id: 3,
    name: 'Amit Patel',
    batch: 'Udbhav 1.0',
    project: 'Supply Chain Intelligence',
    expertise: 'AI, Operations Research',
    location: 'Gujarat',
    email: 'amit.patel@ongc.co.in'
  }
];

export const faqData = [
  {
    question: 'Who can participate in Udbhav 2.0?',
    answer: 'All ONGC employees are eligible to participate and submit their innovative ideas for digital transformation.'
  },
  {
    question: 'Can I submit multiple ideas?',
    answer: 'Yes, you can submit multiple ideas. Each idea will be evaluated independently based on its merit and potential impact.'
  },
  {
    question: 'What kind of ideas are you looking for?',
    answer: 'We are looking for implementation-ready solutions focusing on AI, data analytics, automation, and digital transformation that can create measurable business impact.'
  },
  {
    question: 'Will I get mentorship support?',
    answer: 'Yes, selected participants will receive mentorship from domain experts, AI specialists, and Udbhav alumni throughout the development process.'
  }
];